import React from 'react';
export function CampaignAbTestIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M17.293 23.121L22 18.414 20.586 17l-3.293 3.293L16 19l-1.414 1.414 2.707 2.707z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 1h-2v2H1v12h10v2h2v-2h10V3H13V1zm-2 4H3v8h8V5zm2 8V5h8v8h-8z"
  }), React.createElement("path", {
    d: "M14 6h6v6h-6V6zM6 23.25L7.25 22l-1.875-1.875L7.25 18.25 6 17l-1.875 1.875L2.25 17 1 18.25l1.875 1.875L1 22l1.25 1.25 1.875-1.875L6 23.25z"
  }));
}